import type { Account, Recurrence } from '../../core'
import { isAfter } from 'date-fns/isAfter'
import { isBefore } from 'date-fns/isBefore'
import { isToday } from 'date-fns/isToday'

/**
 * Returns recurrences that match the given account and date range
 * @param account The account
 * @param dateRange The date range
 */
export const recurrenceFilter =
  (account: Account, dateRange: { start: Date; end: Date }) => (r: Recurrence) =>
    r.accountGuid === account.guid &&
    (isToday(r.expectedDate) || isAfter(r.expectedDate, dateRange.start)) &&
    isBefore(r.expectedDate, dateRange.end)
